import React from 'react';

// Saved filters that aren't stored, by id: what a legacy gadget drawn in
// Studio reads its filters from while they're edited (e.g. a metric list's
// items, see StudioMetricList). useLegacySavedFilter reads one of these in
// place of the stored saved filter of that id.
const DraftSavedFiltersContext = React.createContext<
  Record<string, LegacySavedFilter>
>({});

export default DraftSavedFiltersContext;
